module.exports = __webpack_public_path__ + "img/while.be5030ca.webp";